<template>
  <MTableCell
    class="m-table-cell-dropdown-trigger"
    :class="{'m-table-cell-dropdown-trigger_disabled' : !dropdownEnabled}"
    @click="handleTrigger"
  >
    <div :class="{'m-table-cell-dropdown-trigger__button': dropdownEnabled}">
      <MIcon
        :icon="iconArrowDown"
        class="m-table-cell-dropdown-trigger__state-icon"
        :class="{
          'm-table-cell-dropdown-trigger__state-icon_opened': dropdownActive,
          'm-table-cell-dropdown-trigger_disabled': !dropdownEnabled
        }"
      />
    </div>
  </MTableCell>
</template>

<script>
  import iconArrowDown from 'assets/icons/outline-arrow-down.svg';
  import MIcon from 'components/Design/MIcon';
  import MTableCell from 'components/Data/Tables/MTable/cells/MTableCell';

  export default {
    name: 'MTableCellDropdownTrigger',
    components: {
      MTableCell,
      MIcon
    },
    props: {
      itemKey: {
        type: String,
        default: ''
      },
      tableRow: {
        type: Object,
        default: Object
      },
      index: {
        type: [Number, String],
        default: ''
      },
      openedRowsKeys: {
        type: Array,
        default: Array
      },
      openedNestedRows: {
        type: Array,
        default: Array
      },
      uniqueKeyAttr: {
        type: String,
        default: 'id'
      },
      isDropdownEnabledPredicate: {
        type: Function,
        default: () => true
      }
    },
    data () {
      return {
        iconArrowDown
      };
    },
    computed: {
      nestedTableOpened () {
        return this.openedNestedRows.includes(this.tableRow[this.uniqueKeyAttr]);
      },
      dropdownIsOpened () {
        return this.openedRowsKeys.includes(this.tableRow[this.uniqueKeyAttr]);
      },
      dropdownActive () {
        return this.dropdownIsOpened || this.nestedTableOpened;
      },
      dropdownEnabled () {
        return this.isDropdownEnabledPredicate(this.tableRow);
      }
    },
    methods: {
      handleTrigger () {
        if (this.dropdownEnabled) {
          this.$emit('triggerDropdownState', this.tableRow);
        }
      }
    }
  };
</script>

<style>
  .m-table-cell-dropdown-trigger__button {
    cursor: pointer;

    display: flex;

    justify-content: center;
    align-items: center;

    width: 16px;
    height: 16px;

    padding: 2px;

    margin-top: -1px;

    border-radius: 2px;
  }

  .m-table-cell-dropdown-trigger {
    cursor: pointer;

    padding-left: 0;
    padding-right: 0;

    user-select: none;
  }

  .m-table-cell-dropdown-trigger__state-icon {
    color: var(--text-main-color);

    width: 14px;

    transform: rotate(270deg);

    transition: var(--transition-duration);
  }

  .m-table-cell-dropdown-trigger__state-icon_opened {
    transform: rotate(360deg);
  }

  .m-table-cell-dropdown-trigger_disabled {
    color: var(--gray-text-color);
    cursor: not-allowed;
  }

  .m-table-cell-dropdown-trigger__button:hover {
    background: var(--action-border-color);
  }

  .m-table__row_disabled .m-table-cell-dropdown-trigger__button:hover {
    background: var(--border-color);
  }

  .m-table-cell-dropdown-trigger_disabled .m-table-cell-dropdown-trigger__button:hover {
    background: inherit;
  }
</style>
